// extracted by mini-css-extract-plugin
export default {"wrapper":"Dashboard_wrapper__9RYBd","headingIcon":"Dashboard_headingIcon__KObaR"};